import React, { FC } from 'react'

import { Typography, Box } from '@mui/material'

import { InfoButton } from '../../components/InfoButton'

import { WidgetHeaderType } from './types'

export const ReportWidgetsHeader: FC<WidgetHeaderType> = ({ text, explanation, children }) => {
  return (
    <Box display="flex" justifyContent="space-between" flexWrap={'wrap'}>
      <Box display="flex" alignItems={'center'} justifyContent={'center'} gap={1}>
        <Typography variant="h4" fontSize={{ xs: 14, sm: 20 }}>
          {text}
        </Typography>
        {explanation && (
          <Box mt={1.1}>
            <InfoButton explanation={explanation} />
          </Box>
        )}
      </Box>
      {children}
    </Box>
  )
}
